// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"a05b6730","453":"70a5196b","804":"38d8ec57"}[chunkId] + ".chunk.js";
};